import React from 'react';

import Radium from 'radium';
import Divider from 'muicss/lib/react/divider';

import {A} from 'views/AppElements';
import AppConstants from 'AppConstants';
import MessengerCustomerChat from 'react-messenger-customer-chat';

const Footer = Radium((props) => {
	const currentYear = 1900 + (new Date().getYear());

	return <div id="footer">
				<div id="linksRow" className="flexRow scWidth">
					<div className='linkColumn' id="followUsOn">
						<h3>Follow Us On</h3>

						<ul className='linkList'>
							<li>
								<A href={AppConstants.FB_PAGE}>
									<i className="fa fa-facebook-official" aria-hidden="true"></i>Facebook
								</A> 
							</li>
							<li>
								<A href={AppConstants.INSTA_PAGE}>
									<i className="fa fa-instagram" aria-hidden="true"></i>Instagram
								</A> 
							</li>

							<li>
								<A href={AppConstants.YT_CHANNEL}>
									<i className="fa fa-youtube-play" aria-hidden="true"></i>Youtube
								</A>
							</li>
						</ul>
					</div>

					<div className='linkColumn' id='importantLinks'>
						<h3>Important Links</h3>

						<ul className='linkList'>
							<li><A href="/how-to-make-money">How to Make Money At Home?</A></li>
							<li><A href="/terms-of-use-and-privacy-policy" target="_blank">Terms of Use</A> & <A href="/terms-of-use-and-privacy-policy" target="_blank">Privacy Policy</A></li>
							<li><A href="/dashain/buyonedonateone" target="_blank">Buy One Donate 1</A></li>
						</ul>
					</div>
				</div>

				<Divider id="footerDivider" />

				<div id="copyrightRow" className="scWidth flexRow">
					<span id='copyright'><i className="fa fa-copyright" aria-hidden="true"></i> {currentYear} {AppConstants.APP_NAME}</span>
					<span>Call us at <i style={{color: "#f8941c"}} className="fa fa-phone-square" aria-hidden="true"></i> {AppConstants.CONTACT_NUMBER} or WhatsApp at <i style={{color: "green"}} className="fa fa-whatsapp" aria-hidden="true"></i> {AppConstants.WHATS_APP}.</span>
				</div>

				<MessengerCustomerChat pageId={AppConstants.FB_PAGE_ID} appId={AppConstants.FB_APP_ID} 
									htmlRef={window.location.pathname} 
									themeColor="#ff7e29" />
		</div>
});

export default Footer;



// WEBPACK FOOTER //
// ./src/views/Footer.js